export default {"src":"/_next/static/media/DesignArtwork.1672f1cc.svg","height":76,"width":75,"blurWidth":0,"blurHeight":0};